import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from './../../../../../themes/table';

const Row = ({ children, ...rest}) => {
  return (
    <TableRow>
      { children }
    </TableRow>
  );
}

Row.propTypes = {
  children: PropTypes.node
};

export default Row;
